import React from 'react'
import { useStyles } from './styles'
import { LotDto } from 'src/dto/lot.dto'
import { wheat } from 'src/assets/png'

interface LotCardProps {
  lot: LotDto
  onClick: () => void
}

export const LotCard: React.FC<LotCardProps> = ({ lot, onClick }) => {
  const styles = useStyles()

  return (
    <div className={styles.lotCard} onClick={onClick}>
      <div className={styles.cardHeader}>
        <div className={styles.iconContainer}>
          <img src={wheat} alt='Lote' className={styles.icon} />
        </div>
      </div>

      <div className={styles.cardBody}>
        <h3 className={styles.lotName}>{lot.descricao || '-'}</h3>
        <span className={styles.regime}>{lot.regime || '-'}</span>
      </div>

      <div className={styles.cardFooter}>
        <div className={styles.animalCount}>
          <span className={styles.countLabel}>Animais:</span>
          <span className={styles.countValue}>{lot.animais || '0'}</span>
        </div>
      </div>
    </div>
  )
}
